var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u95E8\u5E97\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u95E8\\u5E97\\u7BA1\\u7406",
    transform: "translate(-682.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u95E8\\u5E97\\u7BA1\\u7406",
    transform: "translate(682.000000, 269.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(0.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FE8440",
    x: 9,
    y: 13.5,
    width: 54,
    height: 49.5,
    rx: 8.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5212831,0 L53.4787169,0 C57.2491911,1.08373196e-15 60.6006899,2.4020334 61.8121295,5.97259217 L68.0549866,24.3725922 C69.6165209,28.9750088 67.1513986,33.9718783 62.5489819,35.5334126 C61.6383367,35.8423815 60.6832063,36 59.7215741,36 L12.2784259,36 C7.41832014,36 3.47842593,32.0601058 3.47842593,27.2 C3.47842593,26.2383678 3.63604446,25.2832374 3.94501337,24.3725922 L10.1878705,5.97259217 C11.3993101,2.4020334 14.7508089,2.46898171e-15 18.5212831,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "#FE8440"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 20.25,
    y: 15.75,
    width: 31.5,
    height: 4.5,
    rx: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(36.000000, 31.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFC06E",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    rx: 17.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7471064,15.8066018 C29.6176727,15.1345421 29.2064717,14.7034282 28.7056627,14.7143803 L28.6011201,14.7143803 C26.8806472,14.7143803 25.4807716,13.3433784 25.4807716,11.6577531 C25.4807716,11.1021837 25.7505912,10.4928495 25.7525825,10.4888669 C26.0144115,9.88976544 25.8153645,9.1891365 25.2776602,8.81718056 L25.2477909,8.79726768 L22.2469197,7.16441143 L22.2150591,7.15047241 C22.0315159,7.0739023 21.8344663,7.03496638 21.6355943,7.03597334 C21.208463,7.03597334 20.7892968,7.20324154 20.5144991,7.48202188 C20.1481021,7.85240147 18.9931549,8.81319799 18.0612321,8.81319799 C17.1203485,8.81319799 15.9584319,7.83248859 15.5910392,7.45513949 C15.3152458,7.17038529 14.8940884,7.00006276 14.4619788,7.00006276 C14.2666379,6.99824722 14.0729289,7.0358376 13.8924704,7.11064665 L13.8606098,7.12458566 L10.7542004,8.79527639 L10.7233354,8.81618492 C10.1841539,9.18603634 9.98325467,9.88646868 10.2444306,10.48588 C10.2474175,10.4918539 10.5162414,11.101188 10.5162414,11.6557618 C10.5162414,13.3423828 9.1163659,14.712389 7.39589297,14.712389 L7.29234599,14.712389 C6.79054138,14.7014369 6.38033603,15.1325508 6.2509023,15.8046106 C6.24094586,15.8573797 6,17.1178651 6,18.1085309 C6,19.0991967 6.24094586,20.3586865 6.2509023,20.4124513 C6.37934039,21.0765458 6.7795893,21.5046728 7.27342875,21.5046728 L7.39688861,21.5046728 C9.11736154,21.5046728 10.5172371,22.8756747 10.5172371,24.5613 C10.5172371,25.1168694 10.2474175,25.7262036 10.2454263,25.7301862 C9.98408854,26.3294081 10.1825305,27.0297916 10.7193528,27.4028682 L10.7492222,27.4227811 L13.6933416,29.0347288 L13.7242066,29.0476722 C13.9064095,29.1253324 14.103547,29.1641625 14.3016801,29.1631669 C14.7337897,29.1631669 15.1559428,28.9889292 15.4287492,28.6982011 C15.7732421,28.3318041 16.9739888,27.2823952 17.9367766,27.2823952 C18.9045426,27.2823952 20.0873678,28.3258302 20.4617299,28.7280704 C20.9034915,29.1825695 21.575975,29.3253247 22.1642813,29.0894892 L22.1961419,29.0765458 L25.2477909,27.4247723 L25.2776602,27.4038638 C25.8143124,27.0374668 26.0194151,26.3186118 25.7545737,25.7341687 C25.7515868,25.7281949 25.4827629,25.1188607 25.4827629,24.564287 C25.4827629,22.8786616 26.8826385,21.5076597 28.6031114,21.5076597 L28.707654,21.5076597 C29.208463,21.5186118 29.619664,21.0874979 29.7490977,20.4154382 C29.7590541,20.3616734 30,19.104175 30,18.1115178 C29.9990044,17.1188607 29.7570629,15.859371 29.7471064,15.8066018 L29.7471064,15.8066018 Z M17.946733,22.1657804 C15.6557561,22.1657804 13.7919104,20.3397692 13.7919104,18.0955875 C13.7919104,15.8514058 15.6557561,14.0253946 17.946733,14.0253946 C20.23771,14.0253946 22.1015557,15.8514058 22.1015557,18.0955875 C22.1015557,20.3397692 20.23771,22.1657804 17.946733,22.1657804 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.2d80c143f9baa2a8abe192125f80feb4.svg";
export { ForwardRef as ReactComponent };